export const isSlackPrompt = (prompt) => 'slackUserId' in prompt;
export const isAiConversationMessageComplete = (message) => 'response' in message && 'respondedAt' in message;
//# sourceMappingURL=requestTypes.js.map